import { DashboardCard } from "../../dashboard-card";
import type { EligibilityResult } from "../types";

export interface EligibilityContentProps {
  eligibilityResults: EligibilityResult[];
}

export function EligibilityContent({ eligibilityResults }: EligibilityContentProps) {
  return (
    <div className="flex-1 overflow-y-auto space-y-4 pr-2">
      {eligibilityResults.map((result) => {
        // Determine status display based on result status
        const statusDisplay = result.statusText || result.status;
        const subtitle = result.type;
        const subtitleSecondary = result.results?.length
          ? `${result.results.filter((r) => r.is_covered).length} covered items`
          : statusDisplay;

        return (
          <DashboardCard
            key={result.id}
            statusLabel=""
            title={result.title}
            subtitle={subtitle}
            subtitleSecondary={subtitleSecondary}
            assignees={null}
            dueDate=""
            priority=""
            timestamp={undefined}
            className="w-full"
          />
        );
      })}
    </div>
  );
}
